exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?minimize!ekko-lightbox/dist/ekko-lightbox.css"), "");

// module
exports.push([module.id, "[data-toggle=lightbox][data-gallery=video-gallery] .video-img-wrapper{position:relative;margin-bottom:.5rem}[data-toggle=lightbox][data-gallery=video-gallery] .video-img-wrapper>img{margin:0!important}[data-toggle=lightbox][data-gallery=video-gallery] .video-img-wrapper:before{content:\"\";position:absolute;left:0;top:0;width:100%;height:100%;background:hsla(0,0%,100%,.5);opacity:0;-webkit-transition:opacity .2s ease-in-out;transition:opacity .2s ease-in-out}[data-toggle=lightbox][data-gallery=video-gallery]:hover .video-img-wrapper:before{opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b8e22e0","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/VideoGallery.vue
// module id = QRM7
// module chunks = 1